var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header'),_c('div',{staticClass:"container contracts"},[_c('h1',{staticClass:"title is-1"},[_vm._v("EASING-Verträge")]),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }